import { Stack } from '@collaborate-health/uikit'
import { styled } from '@mui/material'

export const StyledUserSearchResultContainer = styled(Stack)(({ theme }) => ({
  maxHeight: '180px',
}))

